import { Alert } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';

export function ForbiddenPage() {
  return (
    <Alert color="red" icon={<IconLock />} title="Acceso no permitido" maw={600}>
      Su usuario no tiene permiso para acceder a esta sección.
    </Alert>
  );
}
